<p>data-query-results-base works!</p>
